import { IColumnProps } from "devextreme-react/data-grid";

export const auditFieldColumns = new Map<string, IColumnProps>([
  [
    "createdBy",
    {
      dataField: "createdBy",
    },
  ],
  [
    "lastUpdatedBy",
    {
      dataField: "lastUpdatedBy",
    },
  ],
  [
    "createdTime",
    {
      dataField: "createdTime",
      width: 180,
      customizeText: function (e: any) {
        return new Date(e.value).toLocaleString();
      },
    },
  ],
  [
    "lastUpdatedTime",
    {
      dataField: "lastUpdatedTime",
      width: 180,
      customizeText: function (e: any) {
        return new Date(e.value).toLocaleString();
      },
    },
  ],
]);

export const auditFieldNames: string[] = ["createdBy", "lastUpdatedBy", "createdTime", "lastUpdatedTime"];